export const post = async (url: string, data: any) => {
    try {
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });

        return res.json();
    } catch (error) {
        console.log(error);
    }
};

export const debounce = (func: any, delay = 1000) => {
    let timeout: any;

    return (...args: any) => {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };

        clearTimeout(timeout);
        timeout = setTimeout(later, delay);
    };
};
